import { MODULE_NAME as CAMPAIGNS_MODULE } from 'modules/campaigns/config/routes/module';
import { realtimeReportVisibilityCondition } from '../../../../../config/report-predicates/realtimeReportVisibilityCondition';
import * as FIELDS from '../../fields';
import { FILTER_TYPE } from '../../filters';
import { REPORT_PRESET } from '../../pickers';
import { normalizedCountryReportColumnDefinition } from './columnDefinitions';
import { COUNTRY_REALTIME_REPORT_ID } from './countryRealtimeReportId';
import { countryReportFooterColumnDefinition } from './footerColumnDefinitions';
import { graphConfigs } from './graph';
import { defaultColumns, customColumns } from './reportPresets';

export const countryRealtimeReportConfig = {
    id: COUNTRY_REALTIME_REPORT_ID,
    label: 'Countries',
    permissions: ['TA_REALTIME_COUNTRY_REPORT'],
    visibilityCondition: realtimeReportVisibilityCondition,
    module: CAMPAIGNS_MODULE,
    endpoint: 'campaign-realtime-report-by-country',
    graph: graphConfigs,
    rowIdField: FIELDS.COUNTRY_CODE.field,
    columnsDef: normalizedCountryReportColumnDefinition,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: countryReportFooterColumnDefinition,
    sortMap: {
        [FIELDS.COUNTRY_CODE.field]: 'countryName',
        [FIELDS.AVERAGE_CPC.field]: 'cpc',
        [FIELDS.CONVERSIONS.field]: 'cpaActionsNum',
        [FIELDS.CONVERSIONS_CLICKS.field]: 'cpaActionsNumFromClicks',
        [FIELDS.CONVERSIONS_VIEWS.field]: 'cpaActionsNumFromViews',
        [FIELDS.CVR.field]: 'cpaConversionRate',
        [FIELDS.CVR_CLICKS.field]: 'cpaConversionRateClicks',
        [FIELDS.CVR_VIEWS.field]: 'cpaConversionRateViews',
    },
    customRestrictedFilters: {},
    filters: [
        {
            id: FILTER_TYPE.PLATFORM,
            permissions: ['TA_REAL_TIME_REPORT_FILTERS'],
        },
        {
            id: FILTER_TYPE.SITE,
            permissions: ['TA_REAL_TIME_REPORT_FILTERS'],
        },
    ],
};

export default countryRealtimeReportConfig;
